<script>
    export default {
        /////////////////////////////////////////////////////
        // Data
        /////////////////////////////////////////////////////
        data() {
            return {}
        },
        /////////////////////////////////////////////////////
        // Props
        /////////////////////////////////////////////////////
        props: {
            'step': {
                type: Number,
                default: 0
            },
            'dataLoaded': {
                type: Boolean,
                default: false
            }
        },
        /////////////////////////////////////////////////////
        // Mounted
        /////////////////////////////////////////////////////
        mounted() {
            document.addEventListener('DOMContentLoaded', this.videoInit, false);
        },
        /////////////////////////////////////////////////////
        // Watch
        /////////////////////////////////////////////////////
        watch: {
            step: function (val) {
                switch(val) {
                    case 3:
                        setTimeout(this.nextStep, 15000);
                        break
                }
            }
        },
        /////////////////////////////////////////////////////
        // Computed
        /////////////////////////////////////////////////////
        computed: {
        },
        /////////////////////////////////////////////////////
        // Methods
        /////////////////////////////////////////////////////
        methods: {
            nextPage() {
                if (this.step == 4) {
                    window.location = '06.html'
                }
            },
            nextStep() {
                this.$emit('next', parseInt(this.step) + 1);
            },
            prevStep() {
                this.$emit('prev', parseInt(this.step) - 1);
            },
            videoInit() {
                var _video = document.getElementById('video-player');
                _video.addEventListener('playing', this.playClicked, false);
            },
            playClicked() {
                this.$emit('next', 3);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// _vue/components/Page-05.vue